
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import vSelect3 from "vselect3";
import { LastTimeAlarmAdvancedFilterRule, DeviceTypeAdvancedFilterRule }
	from "@/types/sv-data/system-view/advanced-filters/AdvancedStatusFilterRules";

interface ComparisonOptions {
	title: string,
	value: boolean
}

@Component({
	components: {
		"v-select-3": vSelect3
	}
})
export default class LastTimeAlarmAdvancedFilter extends Vue {
	@Prop(Object) value: LastTimeAlarmAdvancedFilterRule;
	@Prop(Object) deviceTypeRule: DeviceTypeAdvancedFilterRule;

	public static readonly RuleIdentifier: string = "LastTimeAlarm";

	private readonly ApplicableDeviceType: number = -1;

	private isRuleApplicable: boolean = false;

	private comparisonOptions: ComparisonOptions[] = [
		{ title: `Later Than`, value: true },
		{ title: `Within`, value: false }
	];

	private ruleSettings: LastTimeAlarmAdvancedFilterRule = {
		filterRuleType: LastTimeAlarmAdvancedFilter.RuleIdentifier,
		enabled: false,
		period: 0,
		greaterThan: true
	};

	private async mounted(): Promise<void> {
		if(this.value !== null) {
			this.ruleSettings = this.value;
		}
		await this.updateApplicability();
	}

	@Watch("deviceTypeRule", { deep: true })
	private async updateApplicability(): Promise<void> {
		if(this.deviceTypeRule !== null) {
			this.isRuleApplicable = this.deviceTypeRule.deviceType == this.ApplicableDeviceType
				&& this.deviceTypeRule.enabled;
		}
		else {
			this.isRuleApplicable = false;
		}
	}

	@Watch("ruleSettings", { deep: true })
	private async ruleUpdated(): Promise<void> {
		this.$emit("input", this.ruleSettings);
	}
}
